import { settings } from "./settings";

export const urlGenerator = resource => {
  if (resource.includes("-cms")) {
    resource = resource.replace("-cms", "");
    return `${settings.cmsAdminApi}/${resource}`;
  }

  return `${settings.gatewayApi}/${resource}`;
};
